<script>
import { mapActions } from "vuex";

import { Page, Footer } from "@styled/global";

export default {
   async mounted() {
      await this.signOut();
      const self = this;
      setTimeout(() => {
         self.$router.push("/signin");
      }, 2000);
   },
   methods: {
      ...mapActions("auth", ["signOut"]),
   },
   render() {
      return (
         <Page>
            <ShadowHeader />
            <h2 style={{ margin: "40px", fontSize: "32px", color: "#ccc" }}>
               User signed out
            </h2>
         </Page>
      );
   },
};
</script>
